<template>
      <el-scrollbar class="bar-visible">
        <el-menu ref="alarmMenu" mode="vertical" class="settings-sub-menu" :default-active="defaultActiveMenu">
          <el-menu-item v-for="(item, index) in alarmList" :key="index" :index="item.filterGroupId" @click="onClickalarmList(item)">
            {{item.filterGroupName}}
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
</template>

<script>
import msgUtil from '@/utils/message';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import BaselineAPI from '@/api/settings/log/lms-baseline-setting';
import { defaultProps } from '@/constants/tree';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WLogBaselineMenu',
  components: {
    WSettingsContentTemplate,
  },
  props: {
    managetypeList: Array,
  },
  data() {
    return {
      defaultProps,
      defaultActiveMenu: null,
      targetData: null,
      alarmList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 필터 그룹 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      BaselineAPI.getFilterGroup().then((response) => {
        if (response.data.success) {
          this.alarmList = response.data.data;
          if (!isEmpty(this.alarmList)) {
            this.$nextTick(() => {
              this.targetData = this.alarmList[0];
              this.defaultActiveMenu = this.alarmList[0].filterGroupId;

              this.onClickalarmList(this.targetData);
            });
          }
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 그룹', false));
        throw new Error(e);
      });
    },
    onClickalarmList(targetData) {
      this.targetData = targetData;
      this.$emit('select-node', this.targetData);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/components/LogBaselineMenu.vue